import { Row, Col, Container } from "react-bootstrap";
import Styles from "./index.module.css";

const Footer = () => {
  return (
    <Container>
      {" "}
      <Row className={Styles.footer}>
        <Col xs={12} className={Styles.socialLinks}>
          <div>
            <a
              href="https://www.facebook.com/learnersbucket/"
              title="Like on Facebook"
              target="_blank"
              rel="noreferrer"
            >
              <i className="fab fa-facebook-square"></i>
            </a>
            <a
              href="https://twitter.com/LearnersBucket"
              title="Follow on Twitter"
              target="_blank"
              rel="noreferrer"
            >
              <i className="fab fa-twitter"></i>
            </a>
            <a
              href="https://www.linkedin.com/company/learnersbucket/"
              title="Check on Linkden"
              target="_blank"
              rel="noreferrer"
            >
              <i className="fab fa-linkedin"></i>
            </a>
            <a
              href="https://github.com/learnersbucket"
              title="Fork on Github"
              target="_blank"
              rel="noreferrer"
            >
              <i className="fab fa-github-square"></i>
            </a>
          </div>
        </Col>
        <Col xs={12} className={Styles.madeBy}>
          Handcrafted with{" "}
          <span>
            <i className="fa fa-heart"></i>
          </span>{" "}
          somewhere in <b>Mumbai</b>
        </Col>
        <Col xs={12} className={Styles.copyright}>
          © {new Date().getFullYear()}{" "}
          <a href="https://learnersbucket.com">LearnersBucket</a>{" "}
          <span className="sep"> | </span>
          <a
            className="credits"
            href="https://learnersbucket.com"
            target="_blank"
            title="Prashant Yadav | Software Engineer"
            alt="Prashant Yadav"
            rel="noreferrer"
          >
            Prashant Yadav
          </a>
        </Col>
      </Row>
    </Container>
  );
};

export default Footer;
